(function ($, Drupal) {
  Drupal.behaviors.navbarColorOpacity= {
    attach: function (context, settings) {
      if ($(context).find(".navbar").length > 0) {
        const navbar = $(".navbar", context);

        function getAdminOffset() {
          return parseInt(getComputedStyle(document.documentElement).getPropertyValue("--drupal-displace-offset-top")) || 0;
        }

        function updateNavbarOpacity() {
          const scrollPosition = $(window).scrollTop();
          const navbarHeight = navbar.outerHeight() || 0;
          const adminOffset = getAdminOffset();

          if (scrollPosition > (navbarHeight + adminOffset)) {
            navbar.css("--bs-bg-opacity", "0.2");
            navbar.css('border-bottom', "var(--bs-border-width) solid var(--bs-border-color)");
          } else {
            navbar.css("--bs-bg-opacity", "1");
            navbar.css("border-bottom", "0");
          }
        }

        $(window).on("scroll", updateNavbarOpacity);
        updateNavbarOpacity();

      }

    }
  };
})(jQuery, Drupal);
